<template functional>
  <section class="subscriptions">
    <template
      v-if="
        props.activeSubscriptions &&
          props.activeSubscriptions.length &&
          typeof props.activeSubscriptions !== 'string'
      "
    >
      <div class="subscriptions__header">
        <div class="subscriptions__col">State</div>
        <div class="subscriptions__col">Started On</div>
        <div class="subscriptions__col">Current Period Ends</div>
      </div>
      <article
        v-for="(subscription, idx) in props.activeSubscriptions"
        :key="`subscription-${idx}`"
        class="subscriptions__single"
      >
        <main class="subscriptions__row">
          <div class="subscriptions__col">{{ subscription.state }}</div>
          <div class="subscriptions__col">
            {{ subscription.start_date | formatDate }}
          </div>
          <div
            v-if="
              subscription.current_period_ends_at.date &&
                subscription.current_period_ends_at.date !== ''
            "
            class="subscriptions__col"
          >
            {{ subscription.current_period_ends_at | formatDate }}
          </div>
          <div v-else class="subscriptions_col">
            {{ subscription.expires_at | formatDate }}
          </div>
        </main>
      </article>
    </template>
    <template v-else-if="typeof props.activeSubscriptions === 'string'">
      <h4 class="subscriptions__error">{{ props.activeSubscriptions }}</h4>
    </template>
    <template v-else>
      <h4 class="subscriptions__error">
        There are no current subscriptions for this account
      </h4>
    </template>
  </section>
</template>

<script>
import moment from 'moment'

export default {
  name: 'UserDashboardSubscription',
  props: {
    activeSubscriptions: {
      type: [Array, String],
      required: true,
    },
  },
  filters: {
    formatDate(obj) {
      return moment(new Date(obj.date)).format('MMMM DD, YYYY')
    },
  },
}
</script>

<style lang="scss" scoped>
.subscriptions {
  $this: &;
  &__single {
    color: var(--white);
    width: 100%;
    font-size: 1rem;
    padding: 20px 0px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    text-transform: capitalize;
  }
  &__row {
    @media (min-width: 769px) {
      display: flex;
    }
  }
  &__header {
    display: none;
    @media (min-width: 769px) {
      display: flex;
      color: var(--gray);
      text-transform: uppercase;
      justify-content: space-between;
      margin-bottom: 10px;
    }
  }
  &__col {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: (100 / 3) * 1%;
  }
  &__error {
    margin: 25px 0;
    color: var(--gray);
    font-weight: 400;
    display: block;
    text-align: center;
    font-size: (24 / 16) * 1rem;
    @media (min-width: 769px) {
      margin: 45px 0;
    }
  }
}
</style>
